/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeatureDetailsModel } from '../../models/feature-details-model';

export interface GetAllFeatureDetailsForSelectedVersion$Params {
  year?: string;
  version?: string;
}

export function getAllFeatureDetailsForSelectedVersion(http: HttpClient, rootUrl: string, params?: GetAllFeatureDetailsForSelectedVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureDetailsModel>>> {
  const rb = new RequestBuilder(rootUrl, getAllFeatureDetailsForSelectedVersion.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('version', params.version, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeatureDetailsModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getAllFeatureDetailsForSelectedVersion.PATH = '/api/featuredetails/getallfeaturedetailsforselectedversion';
getAllFeatureDetailsForSelectedVersion.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getAllFeatureDetailsForSelectedVersion.ROOTURL = '/portal';
